import React from "react";
import { Dialog, DialogContent } from "app/components/Dialog";
import AttachmentPreview from "app/containers/Features/containers/Ticket/components/AttachmentPreview";
import type { TicketAttachmentFile } from "app/containers/Features/containers/Ticket/types";

type AttachmentPreviewDialogProps = {
  isOpen: boolean;
  previewFile: TicketAttachmentFile | null;
  loading?: boolean;
  onClose: () => void;
  onDownload: () => void;
  onOpenFile: () => void;
  onCopyUrl: () => void;
  onDelete: () => void;
  onRenameSubmit: (name: string) => void;
  onPrevious?: () => void;
  onNext?: () => void;
  currentItemNumber: number;
  totalItems: number;
};

const AttachmentPreviewDialog: React.FC<AttachmentPreviewDialogProps> = ({
  isOpen,
  previewFile,
  loading = false,
  onClose,
  onDownload,
  onOpenFile,
  onCopyUrl,
  onDelete,
  onRenameSubmit,
  onPrevious,
  onNext,
  currentItemNumber,
  totalItems,
}) => {
  if (!isOpen || !previewFile) return null;

  return (
    <Dialog
      modal={false}
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="overflow-hidden !p-0 rounded-none bg-white text-left shadow-xl w-screen max-w-none h-screen min-h-screen border-none z-[60]">
        <AttachmentPreview
          fileName={previewFile.name}
          fileType={previewFile.type}
          fileUrl={previewFile.url}
          loading={loading && !previewFile.url}
          onClose={onClose}
          onDownload={onDownload}
          onOpenFile={onOpenFile}
          onCopyUrl={onCopyUrl}
          onDelete={onDelete}
          onRenameSubmit={onRenameSubmit}
          onPrevious={onPrevious}
          onNext={onNext}
          currentItemNumber={currentItemNumber}
          totalItems={totalItems}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AttachmentPreviewDialog;
